module.exports = __webpack_public_path__ + "img/marisa kirisame scarlet_sc2.54bb9c5e.png";